module.exports = __webpack_public_path__ + "static/img/znsb_img_watch.3ab6e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/znsb_img_watch.png
// module id = STjQ
// module chunks = 21